import {get,post} from '../common/axios'
import { getXLS,getXLSPost,getExcelOnline } from './request';
// const API = '/api/'

//用户登录（//暂废止
export const loginApi = p => post('000/001/1', p);
//获取用户详情 (废弃：修改为获取可更新权限)
// export const getUserInfoApi = p=>get(API + 'api/104/001/3',p);
//获取可更新权限
export const getUpdFlagApi = p=>get('api/104/001/3',p);

export const uploadFile = "upload";

const baseURL = '../'

//创建文档
export const createDocumentApi = p => post("api/100/001/1",p);
//更新文档
export const updateDocumentApi = p => post('api/100/002/1',p);
//获取文档详情
export const getDocumentInfoApi = p => get('api/100/003/3',p);
//获取文档列表
export const getDocumentListApi = p => post('api/100/005/1',p);
//获取固定字段
export const getfieldListApi  = p => get('api/102/001/3',p);

export const getDictDataListApi = p => get('api/105/001/3',p);
export const getDictDataInfoApi = p => get('api/105/002/3',p);

//暂废止
export const downFile = 'file/private/';
//用户组列表
export const getGroupsApi = p => get('api/106/001/3',p)
//获取用户所属的用户组列表
export const getUserGroupsApi = p => get('api/104/002/3',p)
//配置用户组
export const addUserGroupApi = p => post('api/106/002/1',p)
//反配置用户组
export const deleteUserGroupApi = p => post('api/106/003/1',p)
// 获取国家树列表
export const getCountryTreeDataApi = p => get('api/countryTree',p)
// 获取全文检索结果
export const getElasticSearchResultsApi = p => get('/api/search',p)

// 导出公司列表Excel信息
export const docExcelExportApi = p => getXLSPost("api/doc/excel/export",p) 
// 导出公司列表Excel信息
export const folderZipExportApi = p => getXLS("/api/zipDownload",p) 

// 根据id删除文档信息
export const delDocByIdApi = p => get("api/del/doc",p) 

// 新增用户配置
export const addUserConfigApi = p => post('/api/userconf/add',p)
// 修改用户配置
export const updateUserConfigApi = p => post('/api/userconf/edit',p)
// 获取用户配置
export const getUserConfigApi = p => get('/api/userconf/info',p)
// 在线预览excel文件，
export const getOnlickExcelUrlApi = p => getExcelOnline(p.url,{},p.callbackFun) 



// WEBPACK FOOTER //
// ./src/service/api.js